import { UserComponent } from './../components/user/user.component';

export const userRoutes = {
    path: 'user',
    component: UserComponent,
    data: {
        breadcrumbs: {
            label: 'Uživatelské nastavení',
            icon: 'users'
        },
        state: 'user-settings'
    }
};
